//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import axios from 'axios'

export default {
  methods: {
    loadOptions (pId) {
      axios.get('/mock/tree.json?pId=' + pId).then(resp => {
        let respData = resp.data
        if (respData.code == '0') {
          if (pId === '' || pId.length === 0) {
            this.options = respData.datas ? respData.datas.code.rows : []
          } else {
            let options = this.options
            options.filter(item => item.id === pId)[0].children = respData.datas ? respData.datas.code.rows : []
            this.$set(this, 'options', [])
            this.$nextTick(_ => {
              this.$set(this, 'options', options)
            })
          }
        }
      })
    },
    loadOptionsEmap (pId) {
      // if (this.options.filter(item => item.pId === pId).length > 0) return
      // axios.get('http://localhost:8080/emap/code/c9fe4e9d-5460-4372-87ca-437d373c2531.do?pId=' + pId).then(resp => {
      //   let respData = resp.data
      //   if (respData.code == '0') {
      //     let options = this.options
      //     if (respData.datas) {
      //       options = options.concat(respData.datas.code.rows)
      //     }
      //     this.$set(this, 'options', options)
      //   }
      // })
    },
    loadMultiOptionsEmap (pId) {
      // if (this.multiOptions.filter(item => item.pId === pId).length > 0) return
      // axios.get('http://localhost:8080/emap/code/c9fe4e9d-5460-4372-87ca-437d373c2531.do?pId=' + pId).then(resp => {
      //   let respData = resp.data
      //   if (respData.code == '0') {
      //     let options = this.multiOptions
      //     if (respData.datas) {
      //       options = options.concat(respData.datas.code.rows)
      //     }
      //     this.$set(this, 'multiOptions', options)
      //   }
      // })
    }
  },

  data() {
    return {
      value: '',
      options: [{
              "id": "1",
              "name": "党群组织",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000010",
              "name": "党群组织\/工会",
              "pId": "1",
              "isParent": 0
          }, {
              "id": "000012",
              "name": "行政部门\/校长办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000423",
              "name": "行政部门\/人事处、人才工作领导小组办公室\/综合科",
              "pId": "000013",
              "isParent": 0
          }, {
              "id": "000426",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/综合科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000371",
              "name": "行政部门\/校区发展与基本建设处\/综合科",
              "pId": "000346",
              "isParent": 0
          }, {
              "id": "000406",
              "name": "行政部门\/新农村发展研究院办公室、江苏农村发展学院办公室、新农村发展研究院和江苏农村发展学院院务委员会秘书处\/综合科",
              "pId": "000401",
              "isParent": 0
          }, {
              "id": "000029",
              "name": "教学机构\/农学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000040",
              "name": "教学机构\/理学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000001",
              "name": "党群组织\/党委办公室、统战部、机关党委",
              "pId": "1",
              "isParent": 0
          }, {
              "id": "000432",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/基建工程招投标科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000021",
              "name": "行政部门\/资产管理与后勤保障处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000100",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/国际教育学院办公室",
              "pId": "000017",
              "isParent": 0
          }, {
              "id": "000101",
              "name": "行政部门\/发展规划办公室\/《中国农业教育》编辑部",
              "pId": "000018",
              "isParent": 0
          }, {
              "id": "000102",
              "name": "行政部门\/产学研合作处\/综合科",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000103",
              "name": "行政部门\/产学研合作处\/科技开发科",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000104",
              "name": "行政部门\/产学研合作处\/科技推广科（科教兴农办公室）",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000105",
              "name": "行政部门\/产学研合作处\/经营性资产管理办公室",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000106",
              "name": "行政部门\/产学研合作处\/资产经营公司财务部",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000107",
              "name": "行政部门\/产学研合作处\/农药厂",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000108",
              "name": "行政部门\/产学研合作处\/免疫生化所",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000109",
              "name": "行政部门\/产学研合作处\/科技开发公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000038",
              "name": "教学机构\/人文社会科学学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000011",
              "name": "党群组织\/团委",
              "pId": "1",
              "isParent": 1
          }, {
              "id": "000360",
              "name": "行政部门\/资产经营公司",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000110",
              "name": "行政部门\/产学研合作处\/神州公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000111",
              "name": "行政部门\/产学研合作处\/高科公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000112",
              "name": "行政部门\/产学研合作处\/资产经营公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000113",
              "name": "行政部门\/产学研合作处\/兴农公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000114",
              "name": "行政部门\/产学研合作处\/动物药业有限公司",
              "pId": "000019",
              "isParent": 0
          }, {
              "id": "000118",
              "name": "行政部门\/资产管理与后勤保障处\/综合科",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000119",
              "name": "行政部门\/资产管理与后勤保障处\/资产管理科",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000338",
              "name": "教学机构\/思想政治理论课教研部",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000045",
              "name": "行政部门\/学术交流中心",
              "pId": "3",
              "isParent": 0
          }, {
              "id": "000120",
              "name": "行政部门\/资产管理与后勤保障处\/房地产管理科",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000121",
              "name": "行政部门\/资产管理与后勤保障处\/动力科",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000122",
              "name": "行政部门\/资产管理与后勤保障处\/社区居民委员会",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000123",
              "name": "行政部门\/资产管理与后勤保障处\/医院",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000124",
              "name": "行政部门\/实验室与基地管理处\/综合科",
              "pId": "000022",
              "isParent": 0
          }, {
              "id": "000125",
              "name": "行政部门\/实验室与基地管理处\/实验室管理科",
              "pId": "000022",
              "isParent": 0
          }, {
              "id": "000126",
              "name": "行政部门\/实验室与基地管理处\/基地管理科",
              "pId": "000022",
              "isParent": 0
          }, {
              "id": "000127",
              "name": "行政部门\/实验室与基地管理处\/设备管理科",
              "pId": "000022",
              "isParent": 0
          }, {
              "id": "000128",
              "name": "行政部门\/白马教学科研基地建设办公室\/综合科",
              "pId": "000023",
              "isParent": 0
          }, {
              "id": "000039",
              "name": "教学机构\/外国语学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000130",
              "name": "直属单位\/图书馆、图书与信息中心\/办公室",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000131",
              "name": "直属单位\/图书馆、图书与信息中心\/读者服务部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000132",
              "name": "直属单位\/图书馆、图书与信息中心\/文献资源建设部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000133",
              "name": "直属单位\/图书馆、图书与信息中心\/参考咨询部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000134",
              "name": "直属单位\/图书馆、图书与信息中心\/网络运营部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000135",
              "name": "直属单位\/图书馆、图书与信息中心\/信息应用部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000136",
              "name": "直属单位\/图书馆、图书与信息中心\/用户服务部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000137",
              "name": "直属单位\/图书馆、图书与信息中心\/教育技术部（现代教育技术中心）",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000138",
              "name": "直属单位\/体育部\/办公室",
              "pId": "000025",
              "isParent": 0
          }, {
              "id": "000139",
              "name": "直属单位\/体育部\/教学与科研教研室",
              "pId": "000025",
              "isParent": 0
          }, {
              "id": "000041",
              "name": "教学机构\/信息科学技术学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000140",
              "name": "直属单位\/体育部\/运动竞赛教研室",
              "pId": "000025",
              "isParent": 0
          }, {
              "id": "000141",
              "name": "直属单位\/体育部\/群众体育教研室",
              "pId": "000025",
              "isParent": 0
          }, {
              "id": "000142",
              "name": "直属单位\/后勤集团公司\/办公室",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000143",
              "name": "直属单位\/后勤集团公司\/人力资源管理中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000144",
              "name": "直属单位\/后勤集团公司\/安全质量管理中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000145",
              "name": "直属单位\/后勤集团公司\/维修动力服务中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000146",
              "name": "直属单位\/后勤集团公司\/通讯接待服务中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000147",
              "name": "直属单位\/后勤集团公司\/物资供应中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000148",
              "name": "直属单位\/后勤集团公司\/文印服务中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000149",
              "name": "直属单位\/后勤集团公司\/饮食服务中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000042",
              "name": "教学机构\/生命科学学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000150",
              "name": "直属单位\/后勤集团公司\/物业管理服务中心",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000151",
              "name": "直属单位\/后勤集团公司\/幼儿园",
              "pId": "000026",
              "isParent": 0
          }, {
              "id": "000152",
              "name": "直属单位\/江浦实验农场\/办公室",
              "pId": "000027",
              "isParent": 0
          }, {
              "id": "000153",
              "name": "直属单位\/江浦实验农场\/生产科",
              "pId": "000027",
              "isParent": 0
          }, {
              "id": "000154",
              "name": "直属单位\/实验牧场\/办公室",
              "pId": "000028",
              "isParent": 0
          }, {
              "id": "000155",
              "name": "教学机构\/农学院\/办公室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000156",
              "name": "教学机构\/农学院\/农学系",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000157",
              "name": "教学机构\/农学院\/遗传育种系",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000158",
              "name": "教学机构\/农学院\/作物学实验教学中心",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000159",
              "name": "教学机构\/农学院\/农学试验站",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000383",
              "name": "教学机构\/农村发展学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000016",
              "name": "行政部门\/科技处、人文社会科学处",
              "pId": "3",
              "isParent": 0
          }, {
              "id": "000160",
              "name": "教学机构\/农学院\/作物遗传与种质创新国家重点实验室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000161",
              "name": "教学机构\/植物保护学院\/办公室",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000162",
              "name": "教学机构\/植物保护学院\/植物病理学系",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000163",
              "name": "教学机构\/植物保护学院\/昆虫学系",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000164",
              "name": "教学机构\/植物保护学院\/农业气象教研室",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000165",
              "name": "教学机构\/植物保护学院\/农药科学系",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000166",
              "name": "教学机构\/植物保护学院\/有害生物综合治理实验教学中心",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000167",
              "name": "教学机构\/资源与环境科学学院\/办公室",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000168",
              "name": "教学机构\/资源与环境科学学院\/土壤与生态学系",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000169",
              "name": "教学机构\/资源与环境科学学院\/植物营养与肥料学系",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000384",
              "name": "教学机构\/草业学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000017",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室",
              "pId": "4",
              "isParent": 1
          }, {
              "id": "000170",
              "name": "教学机构\/资源与环境科学学院\/环境科学与工程系",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000171",
              "name": "教学机构\/资源与环境科学学院\/农业资源与环境实验教学中心",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000172",
              "name": "教学机构\/园艺学院\/办公室",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000173",
              "name": "教学机构\/园艺学院\/园艺学系",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000174",
              "name": "教学机构\/园艺学院\/园林学系",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000175",
              "name": "教学机构\/园艺学院\/中药材科学系",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000176",
              "name": "教学机构\/园艺学院\/园艺园林实验教学中心",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000177",
              "name": "教学机构\/园艺学院\/中药学实验教学中心",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000178",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/办公室",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000179",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/动物遗传育种与繁殖系",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000385",
              "name": "教学机构\/金融学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000018",
              "name": "行政部门\/发展规划办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000180",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/动物营养与饲料科学系",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000181",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/特种经济动物与水产系",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000182",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/草业工程系",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000183",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/动物科学实验教学中心",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000184",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院",
              "pId": "000033",
              "isParent": 1
          }, {
              "id": "000185",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/办公室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000186",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/水产遗传育种室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000187",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/生物技术室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000188",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/大水面增养殖与生态室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000189",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/渔业环境保护生物控制室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000043",
              "name": "教学机构\/工学院（含乡镇企业学院）",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000019",
              "name": "行政部门\/产学研合作处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000190",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/动物饲料与疾病防治室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000191",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/水产养殖室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000192",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/渔业经济和信息室",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000193",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/无锡渔业学院\/教育培训基础部",
              "pId": "000184",
              "isParent": 0
          }, {
              "id": "000194",
              "name": "教学机构\/动物医学院\/办公室",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000195",
              "name": "教学机构\/动物医学院\/附属动物医院",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000196",
              "name": "教学机构\/动物医学院\/基础医学系",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000197",
              "name": "教学机构\/动物医学院\/预防医学系",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000198",
              "name": "教学机构\/动物医学院\/临床医学系",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000199",
              "name": "教学机构\/动物医学院\/基础兽医学实验教学中心",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000002",
              "name": "党群组织\/纪委办公室",
              "pId": "1",
              "isParent": 0
          }, {
              "id": "2",
              "name": "党群组织行政部门",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000427",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/校园一卡通中心",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000433",
              "name": "行政部门\/校区发展与基本建设处\/计划科",
              "pId": "000346",
              "isParent": 0
          }, {
              "id": "000347",
              "name": "行政部门\/发展规划与学科建设处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000407",
              "name": "行政部门\/新农村发展研究院办公室、江苏农村发展学院办公室、新农村发展研究院和江苏农村发展学院院务委员会秘书处\/基地与推广科",
              "pId": "000401",
              "isParent": 0
          }, {
              "id": "000030",
              "name": "教学机构\/植物保护学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000044",
              "name": "教学机构\/继续教育学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000020",
              "name": "行政部门\/基建处",
              "pId": "3",
              "isParent": 0
          }, {
              "id": "000200",
              "name": "教学机构\/动物医学院\/预防兽医学实验教学中心",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000201",
              "name": "教学机构\/动物医学院\/临床兽医学实验教学中心",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000202",
              "name": "教学机构\/食品科技学院\/办公室",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000203",
              "name": "教学机构\/食品科技学院\/食品科学与工程系",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000204",
              "name": "教学机构\/食品科技学院\/生物工程系",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000205",
              "name": "教学机构\/食品科技学院\/食品质量与安全系",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000206",
              "name": "教学机构\/食品科技学院\/食品加工与质量控制实验教学中心",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000207",
              "name": "教学机构\/食品科技学院\/生物工程实验教学中心",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000208",
              "name": "教学机构\/食品科技学院\/国家肉品质量控制工程技术研究中心",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000209",
              "name": "教学机构\/经济管理学院\/办公室",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000210",
              "name": "教学机构\/经济管理学院\/农业经济学系",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000211",
              "name": "教学机构\/经济管理学院\/管理学系",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000213",
              "name": "教学机构\/经济管理学院\/经济管理与电子商务实验教学中心",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000214",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/办公室",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000215",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/土地管理系",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000216",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/资源环境与城乡规划系",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000217",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/人力资源与社会保障系",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000218",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/行政管理系",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000219",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/管理学科教学实验中心",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000022",
              "name": "行政部门\/实验室与基地管理处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000220",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/高等教育研究所",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000221",
              "name": "教学机构\/人文社会科学学院\/办公室",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000222",
              "name": "教学机构\/人文社会科学学院\/中国近现代史教研室",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000223",
              "name": "教学机构\/人文社会科学学院\/马克思主义基本原理教研室",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000224",
              "name": "教学机构\/人文社会科学学院\/社会学系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000225",
              "name": "教学机构\/人文社会科学学院\/文化管理系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000226",
              "name": "教学机构\/人文社会科学学院\/旅游管理系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000227",
              "name": "教学机构\/人文社会科学学院\/科学技术史系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000228",
              "name": "教学机构\/人文社会科学学院\/法律系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000229",
              "name": "教学机构\/人文社会科学学院\/人文综合实验教学中心",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000230",
              "name": "教学机构\/外国语学院\/办公室",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000231",
              "name": "教学机构\/外国语学院\/英语系",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000232",
              "name": "教学机构\/外国语学院\/日语系",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000233",
              "name": "教学机构\/外国语学院\/公共外语教学部",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000234",
              "name": "教学机构\/外国语学院\/外语实验教学中心",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000235",
              "name": "教学机构\/理学院\/办公室",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000236",
              "name": "教学机构\/理学院\/数学系",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000237",
              "name": "教学机构\/理学院\/物理系",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000238",
              "name": "教学机构\/理学院\/化学系",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000239",
              "name": "教学机构\/理学院\/化学实验教学中心",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000024",
              "name": "直属单位\/图书馆、图书与信息中心",
              "pId": "9",
              "isParent": 1
          }, {
              "id": "000240",
              "name": "教学机构\/理学院\/物理实验教学中心",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000241",
              "name": "教学机构\/信息科学技术学院\/办公室",
              "pId": "000041",
              "isParent": 0
          }, {
              "id": "000242",
              "name": "教学机构\/信息科学技术学院\/计算机科学与技术系",
              "pId": "000041",
              "isParent": 0
          }, {
              "id": "000243",
              "name": "教学机构\/信息科学技术学院\/信息管理系",
              "pId": "000041",
              "isParent": 0
          }, {
              "id": "000244",
              "name": "教学机构\/信息科学技术学院\/计算机与信息技术实验教学中心",
              "pId": "000041",
              "isParent": 0
          }, {
              "id": "000245",
              "name": "教学机构\/生命科学学院\/办公室",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000246",
              "name": "教学机构\/生命科学学院\/生物化学与分子生物学系",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000247",
              "name": "教学机构\/生命科学学院\/微生物学系",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000248",
              "name": "教学机构\/生命科学学院\/植物生物学系",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000249",
              "name": "教学机构\/生命科学学院\/动物生物学系",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000025",
              "name": "直属单位\/体育部",
              "pId": "9",
              "isParent": 1
          }, {
              "id": "000250",
              "name": "教学机构\/生命科学学院\/生物学实验教学中心",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000251",
              "name": "教学机构\/继续教育学院\/办公室",
              "pId": "000044",
              "isParent": 0
          }, {
              "id": "000252",
              "name": "教学机构\/继续教育学院\/培训科",
              "pId": "000044",
              "isParent": 0
          }, {
              "id": "000253",
              "name": "教学机构\/继续教育学院\/教务科",
              "pId": "000044",
              "isParent": 0
          }, {
              "id": "000254",
              "name": "教学机构\/继续教育学院\/招生自考办公室",
              "pId": "000044",
              "isParent": 0
          }, {
              "id": "000256",
              "name": "教学机构\/工学院（含乡镇企业学院）\/党委办公室",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000257",
              "name": "教学机构\/工学院（含乡镇企业学院）\/党委办公室\/综合科",
              "pId": "000256",
              "isParent": 0
          }, {
              "id": "000258",
              "name": "教学机构\/工学院（含乡镇企业学院）\/纪委办公室、监察室、机关党总支",
              "pId": "000043",
              "isParent": 0
          }, {
              "id": "000259",
              "name": "教学机构\/工学院（含乡镇企业学院）\/工会",
              "pId": "000043",
              "isParent": 0
          }, {
              "id": "000026",
              "name": "直属单位\/后勤集团公司",
              "pId": "9",
              "isParent": 1
          }, {
              "id": "000260",
              "name": "教学机构\/工学院（含乡镇企业学院）\/团委",
              "pId": "000043",
              "isParent": 0
          }, {
              "id": "000261",
              "name": "教学机构\/工学院（含乡镇企业学院）\/院长办公室",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000262",
              "name": "教学机构\/工学院（含乡镇企业学院）\/院长办公室\/综合科",
              "pId": "000261",
              "isParent": 0
          }, {
              "id": "000263",
              "name": "教学机构\/工学院（含乡镇企业学院）\/人事处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000264",
              "name": "教学机构\/工学院（含乡镇企业学院）\/人事处\/综合科",
              "pId": "000263",
              "isParent": 0
          }, {
              "id": "000265",
              "name": "教学机构\/工学院（含乡镇企业学院）\/人事处\/离退休办公室",
              "pId": "000263",
              "isParent": 0
          }, {
              "id": "000267",
              "name": "教学机构\/工学院（含乡镇企业学院）\/教务处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000268",
              "name": "教学机构\/工学院（含乡镇企业学院）\/教务处\/教务科",
              "pId": "000267",
              "isParent": 0
          }, {
              "id": "000269",
              "name": "教学机构\/工学院（含乡镇企业学院）\/教务处\/教研及实践教学科",
              "pId": "000267",
              "isParent": 0
          }, {
              "id": "000027",
              "name": "直属单位\/江浦实验农场",
              "pId": "9",
              "isParent": 1
          }, {
              "id": "000270",
              "name": "教学机构\/工学院（含乡镇企业学院）\/教务处\/教材科",
              "pId": "000267",
              "isParent": 0
          }, {
              "id": "000271",
              "name": "教学机构\/工学院（含乡镇企业学院）\/科技与研究生处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000272",
              "name": "教学机构\/工学院（含乡镇企业学院）\/科技与研究生处\/综合科",
              "pId": "000271",
              "isParent": 0
          }, {
              "id": "000273",
              "name": "教学机构\/工学院（含乡镇企业学院）\/学生工作处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000274",
              "name": "教学机构\/工学院（含乡镇企业学院）\/学生工作处\/招生就业科",
              "pId": "000273",
              "isParent": 0
          }, {
              "id": "000275",
              "name": "教学机构\/工学院（含乡镇企业学院）\/学生工作处\/教育管理科",
              "pId": "000273",
              "isParent": 0
          }, {
              "id": "000276",
              "name": "教学机构\/工学院（含乡镇企业学院）\/学生工作处\/学生宿舍管理科",
              "pId": "000273",
              "isParent": 0
          }, {
              "id": "000277",
              "name": "教学机构\/工学院（含乡镇企业学院）\/计划财务处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000278",
              "name": "教学机构\/工学院（含乡镇企业学院）\/计划财务处\/综合财务科",
              "pId": "000277",
              "isParent": 0
          }, {
              "id": "000279",
              "name": "教学机构\/工学院（含乡镇企业学院）\/计划财务处\/校园卡管理科",
              "pId": "000277",
              "isParent": 0
          }, {
              "id": "000028",
              "name": "直属单位\/实验牧场",
              "pId": "9",
              "isParent": 1
          }, {
              "id": "000280",
              "name": "教学机构\/工学院（含乡镇企业学院）\/计划财务处\/服务核算科",
              "pId": "000277",
              "isParent": 0
          }, {
              "id": "000281",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000282",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/办公室",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000283",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/基建维修科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000284",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/资产管理科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000285",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/保卫科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000286",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/卫生所",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000287",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/水电管理科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000288",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/物业管理科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000289",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/饮食服务中心",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000290",
              "name": "教学机构\/工学院（含乡镇企业学院）\/总务处\/服务管理科",
              "pId": "000281",
              "isParent": 0
          }, {
              "id": "000291",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000292",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）\/办公室",
              "pId": "000291",
              "isParent": 0
          }, {
              "id": "000293",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）\/农业机械教研室",
              "pId": "000291",
              "isParent": 0
          }, {
              "id": "000294",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）\/交通运输教研室",
              "pId": "000291",
              "isParent": 0
          }, {
              "id": "000295",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）\/车辆工程教研室",
              "pId": "000291",
              "isParent": 0
          }, {
              "id": "000296",
              "name": "教学机构\/工学院（含乡镇企业学院）\/农业机械化系（交通与车辆工程系）\/农业机械与车辆工程实验中心",
              "pId": "000291",
              "isParent": 0
          }, {
              "id": "000297",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000298",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/办公室",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000299",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/机械设计教研室",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000003",
              "name": "党群组织\/监察处",
              "pId": "1",
              "isParent": 1
          }, {
              "id": "3",
              "name": "行政部门",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000428",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/收费与财税科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000372",
              "name": "行政部门\/校区发展与基本建设处\/工程管理科",
              "pId": "000346",
              "isParent": 0
          }, {
              "id": "000376",
              "name": "行政部门\/发展委员会办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000413",
              "name": "行政部门\/新农村发展研究院办公室、江苏农村发展学院办公室、新农村发展研究院和江苏农村发展学院院务委员会秘书处\/发展研究科",
              "pId": "000401",
              "isParent": 0
          }, {
              "id": "000031",
              "name": "教学机构\/资源与环境科学学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000300",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/工业设计教研室",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000301",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/机械制造教研室",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000302",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/材料成型及控制工程教研室",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000303",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/机械工程实验中心",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000304",
              "name": "教学机构\/工学院（含乡镇企业学院）\/机械工程系\/实习中心",
              "pId": "000297",
              "isParent": 0
          }, {
              "id": "000305",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000306",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/办公室",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000307",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/电气工程教研室",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000308",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/自动化教研室",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000309",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/电子信息科学与技术教研室",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000310",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/计算机教研室",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000311",
              "name": "教学机构\/工学院（含乡镇企业学院）\/电气工程系\/电工电子教学实验中心",
              "pId": "000305",
              "isParent": 0
          }, {
              "id": "000312",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000313",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系\/办公室",
              "pId": "000312",
              "isParent": 0
          }, {
              "id": "000314",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系\/工业工程教研室",
              "pId": "000312",
              "isParent": 0
          }, {
              "id": "000315",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系\/物流工程教研室",
              "pId": "000312",
              "isParent": 0
          }, {
              "id": "000316",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系\/工程管理教研室",
              "pId": "000312",
              "isParent": 0
          }, {
              "id": "000317",
              "name": "教学机构\/工学院（含乡镇企业学院）\/管理工程系\/实验室",
              "pId": "000312",
              "isParent": 0
          }, {
              "id": "000318",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000319",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/办公室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000320",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/人文与社会科学教研室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000321",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/英语教研室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000322",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/数学教研室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000323",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/物理与化学教研室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000324",
              "name": "教学机构\/工学院（含乡镇企业学院）\/基础课部\/体育教研室",
              "pId": "000318",
              "isParent": 0
          }, {
              "id": "000325",
              "name": "教学机构\/工学院（含乡镇企业学院）\/培训部",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000326",
              "name": "教学机构\/工学院（含乡镇企业学院）\/培训部\/办公室",
              "pId": "000325",
              "isParent": 0
          }, {
              "id": "000327",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆",
              "pId": "000043",
              "isParent": 1
          }, {
              "id": "000328",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆\/办公室",
              "pId": "000327",
              "isParent": 0
          }, {
              "id": "000329",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆\/资源建设部",
              "pId": "000327",
              "isParent": 0
          }, {
              "id": "000330",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆\/信息服务部",
              "pId": "000327",
              "isParent": 0
          }, {
              "id": "000331",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆\/流通服务部",
              "pId": "000327",
              "isParent": 0
          }, {
              "id": "000332",
              "name": "教学机构\/工学院（含乡镇企业学院）\/图书馆\/技术支持部",
              "pId": "000327",
              "isParent": 0
          }, {
              "id": "000333",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/农业部牛冷冻精液质量监督检验测试中心（南京）",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000335",
              "name": "教学机构\/经济管理学院\/会计与金融学系",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000336",
              "name": "教学机构\/经济管理学院\/经济贸易系",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000339",
              "name": "直属单位\/体育部\/军事理论教研室",
              "pId": "000025",
              "isParent": 0
          }, {
              "id": "000340",
              "name": "教学机构\/思想政治理论课教研部\/办公室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000341",
              "name": "教学机构\/思想政治理论课教研部\/研究生政治理论教研室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000342",
              "name": "教学机构\/思想政治理论课教研部\/道德与法律教研室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000343",
              "name": "教学机构\/思想政治理论课教研部\/近现代史教研室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000344",
              "name": "教学机构\/思想政治理论课教研部\/中国特色社会主义理论教研室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000345",
              "name": "教学机构\/思想政治理论课教研部\/马克思主义原理教研室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000348",
              "name": "教学机构\/农学院\/国家信息农业工程技术中心办公室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000349",
              "name": "行政部门\/发展规划与学科建设处\/综合科",
              "pId": "000347",
              "isParent": 0
          }, {
              "id": "000350",
              "name": "行政部门\/发展规划与学科建设处\/发展规划办公室",
              "pId": "000347",
              "isParent": 0
          }, {
              "id": "000351",
              "name": "行政部门\/发展规划与学科建设处\/重点建设办公室",
              "pId": "000347",
              "isParent": 0
          }, {
              "id": "000353",
              "name": "行政部门\/科学研究院\/科研计划处",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000354",
              "name": "行政部门\/科学研究院\/重大项目处",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000356",
              "name": "行政部门\/科学研究院\/成果与知识产权处",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000357",
              "name": "行政部门\/科学研究院\/实验室与平台处",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000358",
              "name": "行政部门\/科学研究院\/产学研合作处（技术转移中心）",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000359",
              "name": "教学机构\/农学院\/农业部大豆生物学与遗传育种重点实验室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000362",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教学实验室与基地管理科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000363",
              "name": "行政部门\/资产管理与后勤保障处\/设备管理科",
              "pId": "000021",
              "isParent": 0
          }, {
              "id": "000365",
              "name": "行政部门\/校长办公室\/行政科",
              "pId": "000012",
              "isParent": 0
          }, {
              "id": "000366",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/留学生教育管理科",
              "pId": "000017",
              "isParent": 0
          }, {
              "id": "000367",
              "name": "教学机构\/农学院\/种业科学系",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000368",
              "name": "行政部门\/资产经营公司\/投资部",
              "pId": "000360",
              "isParent": 0
          }, {
              "id": "000369",
              "name": "行政部门\/资产经营公司\/开发部",
              "pId": "000360",
              "isParent": 0
          }, {
              "id": "000370",
              "name": "行政部门\/资产经营公司\/财务部",
              "pId": "000360",
              "isParent": 0
          }, {
              "id": "000374",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/学生交流科",
              "pId": "000017",
              "isParent": 0
          }, {
              "id": "000377",
              "name": "党群组织\/监察处\/法制科",
              "pId": "000003",
              "isParent": 0
          }, {
              "id": "000378",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/学生事务管理中心（学生资助管理中心）",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000379",
              "name": "教学机构\/人文社会科学学院\/艺术系",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000380",
              "name": "行政部门\/发展委员会办公室\/校友会办公室",
              "pId": "000376",
              "isParent": 0
          }, {
              "id": "000381",
              "name": "行政部门\/发展委员会办公室\/教育发展基金会办公室",
              "pId": "000376",
              "isParent": 0
          }, {
              "id": "000382",
              "name": "行政部门\/发展委员会办公室\/发展咨询委员会办公室",
              "pId": "000376",
              "isParent": 0
          }, {
              "id": "000386",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教学网络与信息科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000387",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/植物生产国家级实验教学中心办公室",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000388",
              "name": "教学机构\/金融学院\/办公室",
              "pId": "000385",
              "isParent": 0
          }, {
              "id": "000389",
              "name": "教学机构\/资源与环境科学学院\/海洋生物学系",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000390",
              "name": "教学机构\/农村发展学院\/农村发展系",
              "pId": "000383",
              "isParent": 0
          }, {
              "id": "000391",
              "name": "教学机构\/农村发展学院\/社会学系",
              "pId": "000383",
              "isParent": 0
          }, {
              "id": "000392",
              "name": "教学机构\/草业学院\/草业科学系",
              "pId": "000384",
              "isParent": 0
          }, {
              "id": "000393",
              "name": "教学机构\/金融学院\/金融学系",
              "pId": "000385",
              "isParent": 0
          }, {
              "id": "000394",
              "name": "教学机构\/金融学院\/会计学系",
              "pId": "000385",
              "isParent": 0
          }, {
              "id": "000395",
              "name": "教学机构\/农村发展学院\/办公室",
              "pId": "000383",
              "isParent": 0
          }, {
              "id": "000396",
              "name": "教学机构\/草业学院\/办公室",
              "pId": "000384",
              "isParent": 0
          }, {
              "id": "000398",
              "name": "行政部门\/人文社科处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000399",
              "name": "行政部门\/档案馆",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000004",
              "name": "党群组织\/审计处",
              "pId": "1",
              "isParent": 1
          }, {
              "id": "000429",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/会计核算中心核算一科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000023",
              "name": "行政部门\/白马教学科研基地建设办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000373",
              "name": "行政部门\/校区发展与基本建设处\/维修科",
              "pId": "000346",
              "isParent": 0
          }, {
              "id": "4",
              "name": "行政部门教学机构",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000032",
              "name": "教学机构\/园艺学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000400",
              "name": "行政部门\/医院",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000401",
              "name": "行政部门\/新农村发展研究院办公室、江苏农村发展学院办公室、新农村发展研究院和江苏农村发展学院院务委员会秘书处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000402",
              "name": "行政部门\/档案馆\/综合科",
              "pId": "000399",
              "isParent": 0
          }, {
              "id": "000403",
              "name": "行政部门\/档案馆\/保管利用科",
              "pId": "000399",
              "isParent": 0
          }, {
              "id": "000404",
              "name": "行政部门\/人文社科处\/综合科",
              "pId": "000398",
              "isParent": 0
          }, {
              "id": "000405",
              "name": "行政部门\/人文社科处\/项目科",
              "pId": "000398",
              "isParent": 0
          }, {
              "id": "000408",
              "name": "行政部门\/医院\/大内科",
              "pId": "000400",
              "isParent": 0
          }, {
              "id": "000409",
              "name": "行政部门\/医院\/大外科",
              "pId": "000400",
              "isParent": 0
          }, {
              "id": "000410",
              "name": "行政部门\/医院\/护理、药房管理科",
              "pId": "000400",
              "isParent": 0
          }, {
              "id": "000411",
              "name": "行政部门\/医院\/院长办公室",
              "pId": "000400",
              "isParent": 0
          }, {
              "id": "000412",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教师发展中心培训科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000414",
              "name": "行政部门\/人文社科处\/学报编辑部（社会科学版）",
              "pId": "000398",
              "isParent": 0
          }, {
              "id": "000416",
              "name": "党群组织\/组织部、党校、老干部办公室\/中共南京农业大学委员会党校办公室",
              "pId": "000005",
              "isParent": 0
          }, {
              "id": "000417",
              "name": "党群组织\/审计处\/工程审计科",
              "pId": "000004",
              "isParent": 0
          }, {
              "id": "000418",
              "name": "党群组织\/审计处\/财务审计科",
              "pId": "000004",
              "isParent": 0
          }, {
              "id": "000419",
              "name": "行政部门\/校长办公室\/外联科",
              "pId": "000012",
              "isParent": 0
          }, {
              "id": "000420",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/外国专家科",
              "pId": "000017",
              "isParent": 0
          }, {
              "id": "000421",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/国际交流科",
              "pId": "000017",
              "isParent": 0
          }, {
              "id": "000422",
              "name": "行政部门\/发展规划与学科建设处\/《中国农业教育》编辑部",
              "pId": "000347",
              "isParent": 0
          }, {
              "id": "000424",
              "name": "行政部门\/人事处、人才工作领导小组办公室\/薪酬管理科",
              "pId": "000013",
              "isParent": 0
          }, {
              "id": "000425",
              "name": "行政部门\/人事处、人才工作领导小组办公室\/聘用管理科",
              "pId": "000013",
              "isParent": 0
          }, {
              "id": "000434",
              "name": "行政部门\/白马教学科研基地建设办公室\/工程项目科",
              "pId": "000023",
              "isParent": 0
          }, {
              "id": "000435",
              "name": "行政部门\/白马教学科研基地建设办公室\/科教服务科",
              "pId": "000023",
              "isParent": 0
          }, {
              "id": "000436",
              "name": "直属单位\/图书馆、图书与信息中心\/发展研究部",
              "pId": "000024",
              "isParent": 0
          }, {
              "id": "000437",
              "name": "教学机构\/继续教育学院\/远程教育科",
              "pId": "000044",
              "isParent": 0
          }, {
              "id": "000438",
              "name": "教学机构\/农学院\/学生工作办公室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000439",
              "name": "教学机构\/农学院\/国家重点实验室办公室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000440",
              "name": "教学机构\/农学院\/大豆改良中心办公室",
              "pId": "000029",
              "isParent": 0
          }, {
              "id": "000441",
              "name": "教学机构\/植物保护学院\/学生工作办公室",
              "pId": "000030",
              "isParent": 0
          }, {
              "id": "000442",
              "name": "教学机构\/资源与环境科学学院\/学生工作办公室",
              "pId": "000031",
              "isParent": 0
          }, {
              "id": "000443",
              "name": "教学机构\/园艺学院\/学生工作办公室",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000444",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）\/学生工作办公室",
              "pId": "000033",
              "isParent": 0
          }, {
              "id": "000445",
              "name": "教学机构\/动物医学院\/学生工作办公室",
              "pId": "000034",
              "isParent": 0
          }, {
              "id": "000446",
              "name": "教学机构\/食品科技学院\/学生工作办公室",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000447",
              "name": "教学机构\/经济管理学院\/学生工作办公室",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000448",
              "name": "教学机构\/经济管理学院\/MBA教育中心办公室",
              "pId": "000036",
              "isParent": 0
          }, {
              "id": "000449",
              "name": "教学机构\/公共管理学院（含土地管理学院）\/学生工作办公室",
              "pId": "000037",
              "isParent": 0
          }, {
              "id": "000450",
              "name": "教学机构\/理学院\/学生工作办公室",
              "pId": "000040",
              "isParent": 0
          }, {
              "id": "000451",
              "name": "教学机构\/人文社会科学学院\/学生工作办公室",
              "pId": "000038",
              "isParent": 0
          }, {
              "id": "000452",
              "name": "教学机构\/生命科学学院\/学生工作办公室",
              "pId": "000042",
              "isParent": 0
          }, {
              "id": "000453",
              "name": "教学机构\/外国语学院\/学生工作办公室",
              "pId": "000039",
              "isParent": 0
          }, {
              "id": "000454",
              "name": "教学机构\/信息科学技术学院\/学生工作办公室",
              "pId": "000041",
              "isParent": 0
          }, {
              "id": "000455",
              "name": "教学机构\/农村发展学院\/学生工作办公室",
              "pId": "000383",
              "isParent": 0
          }, {
              "id": "000456",
              "name": "教学机构\/金融学院\/学生工作办公室",
              "pId": "000385",
              "isParent": 0
          }, {
              "id": "000457",
              "name": "教学机构\/思想政治理论课教研部\/学生工作办公室",
              "pId": "000338",
              "isParent": 0
          }, {
              "id": "000458",
              "name": "教学机构\/草业学院\/学生工作办公室",
              "pId": "000384",
              "isParent": 0
          }, {
              "id": "000459",
              "name": "行政部门\/资产经营公司\/办公室",
              "pId": "000360",
              "isParent": 0
          }, {
              "id": "000046",
              "name": "校级独立科研机构\/中国新农村建设研究院",
              "pId": "7",
              "isParent": 0
          }, {
              "id": "000460",
              "name": "行政部门\/科学研究院\/《Horticulture Research》期刊编辑部",
              "pId": "000352",
              "isParent": 0
          }, {
              "id": "000461",
              "name": "教学机构\/园艺学院\/设施农业科学与工程学系",
              "pId": "000032",
              "isParent": 0
          }, {
              "id": "000462",
              "name": "教学机构\/食品科技学院\/农业部肉及肉制品质量安全监督检验测试中心（南京）",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000463",
              "name": "教学机构\/金融学院\/投资学系",
              "pId": "000385",
              "isParent": 0
          }, {
              "id": "000464",
              "name": "教学机构\/食品科技学院\/农业部农产品贮藏保鲜质量安全风险评估实验室（南京）",
              "pId": "000035",
              "isParent": 0
          }, {
              "id": "000047",
              "name": "校级独立科研机构\/中华农业文明博物馆",
              "pId": "7",
              "isParent": 0
          }, {
              "id": "000048",
              "name": "校级独立科研机构\/农业生物安全研究中心",
              "pId": "7",
              "isParent": 0
          }, {
              "id": "000049",
              "name": "校级独立科研机构\/农产品安全与质量检测中心",
              "pId": "7",
              "isParent": 0
          }, {
              "id": "000005",
              "name": "党群组织\/组织部、党校、老干部办公室",
              "pId": "1",
              "isParent": 1
          }, {
              "id": "000013",
              "name": "行政部门\/人事处、人才工作领导小组办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000430",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/会计核算中心核算二科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "5",
              "name": "教学机构",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000033",
              "name": "教学机构\/动物科技学院（含无锡渔业学院）",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "000050",
              "name": "校级独立科研机构\/生命科学实验中心",
              "pId": "7",
              "isParent": 0
          }, {
              "id": "000051",
              "name": "党群组织\/宣传部\/宣传教育办公室",
              "pId": "000006",
              "isParent": 0
          }, {
              "id": "000052",
              "name": "党群组织\/宣传部\/新闻中心办公室",
              "pId": "000006",
              "isParent": 0
          }, {
              "id": "000053",
              "name": "党群组织\/宣传部\/校报编辑部",
              "pId": "000006",
              "isParent": 0
          }, {
              "id": "000054",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/综合科",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000055",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/社区学生管理中心",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000056",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/教育管理科",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000057",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/招生办公室",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000058",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/就业办公室（就业指导与服务中心）",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000059",
              "name": "党群组织行政部门\/学生工作处、学生工作部\/大学生心理健康教育中心",
              "pId": "000007",
              "isParent": 0
          }, {
              "id": "000006",
              "name": "党群组织\/宣传部",
              "pId": "1",
              "isParent": 1
          }, {
              "id": "000015",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000034",
              "name": "教学机构\/动物医学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "6",
              "name": "经济实体",
              "pId": "",
              "isParent": 0
          }, {
              "id": "000061",
              "name": "党群组织行政部门\/研究生院、研究生工作部\/院长办公室",
              "pId": "000008",
              "isParent": 0
          }, {
              "id": "000062",
              "name": "党群组织行政部门\/研究生院、研究生工作部\/招生办公室",
              "pId": "000008",
              "isParent": 0
          }, {
              "id": "000063",
              "name": "党群组织行政部门\/研究生院、研究生工作部\/培养处",
              "pId": "000008",
              "isParent": 0
          }, {
              "id": "000064",
              "name": "党群组织行政部门\/研究生院、研究生工作部\/学位办公室",
              "pId": "000008",
              "isParent": 0
          }, {
              "id": "000065",
              "name": "党群组织行政部门\/研究生院、研究生工作部\/研究生教育管理办公室",
              "pId": "000008",
              "isParent": 0
          }, {
              "id": "000066",
              "name": "党群组织行政部门\/保卫处、政保部、人武部\/综合科（政保部）",
              "pId": "000009",
              "isParent": 0
          }, {
              "id": "000067",
              "name": "党群组织行政部门\/保卫处、政保部、人武部\/治安科",
              "pId": "000009",
              "isParent": 0
          }, {
              "id": "000068",
              "name": "党群组织行政部门\/保卫处、政保部、人武部\/校卫队",
              "pId": "000009",
              "isParent": 0
          }, {
              "id": "000069",
              "name": "党群组织\/团委\/办公室",
              "pId": "000011",
              "isParent": 1
          }, {
              "id": "009969",
              "name": "党群组织\/团委\/办公室\/科室",
              "pId": "000069",
              "isParent": 0
          }, {
              "id": "000007",
              "name": "党群组织行政部门\/学生工作处、学生工作部",
              "pId": "2",
              "isParent": 1
          }, {
              "id": "000352",
              "name": "行政部门\/科学研究院",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000035",
              "name": "教学机构\/食品科技学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "7",
              "name": "校级独立科研机构",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000071",
              "name": "行政部门\/校长办公室\/综合科",
              "pId": "000012",
              "isParent": 0
          }, {
              "id": "000072",
              "name": "行政部门\/校长办公室\/文秘科",
              "pId": "000012",
              "isParent": 0
          }, {
              "id": "000075",
              "name": "行政部门\/人事处、人才工作领导小组办公室\/师资科",
              "pId": "000013",
              "isParent": 0
          }, {
              "id": "000078",
              "name": "行政部门\/人事处、人才工作领导小组办公室\/退休管理科（人才交流培训中心）",
              "pId": "000013",
              "isParent": 0
          }, {
              "id": "000079",
              "name": "行政部门\/人才交流培训中心",
              "pId": "3",
              "isParent": 0
          }, {
              "id": "000008",
              "name": "党群组织行政部门\/研究生院、研究生工作部",
              "pId": "2",
              "isParent": 1
          }, {
              "id": "000014",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000036",
              "name": "教学机构\/经济管理学院",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "8",
              "name": "附属单位",
              "pId": "",
              "isParent": 0
          }, {
              "id": "000080",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/会计核算中心",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000082",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/预算科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000083",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/专项资金管理科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000084",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/收费及校园卡科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000085",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/资金管理科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000086",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/综合科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000087",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教学研究与教学质量评估科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000088",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教务科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000089",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/教材科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000009",
              "name": "党群组织行政部门\/保卫处、政保部、人武部",
              "pId": "2",
              "isParent": 1
          }, {
              "id": "000431",
              "name": "行政部门\/计财处、会计核算中心、招投标办公室\/货物采购招投标科",
              "pId": "000014",
              "isParent": 0
          }, {
              "id": "000346",
              "name": "行政部门\/校区发展与基本建设处",
              "pId": "3",
              "isParent": 1
          }, {
              "id": "000037",
              "name": "教学机构\/公共管理学院（含土地管理学院）",
              "pId": "5",
              "isParent": 1
          }, {
              "id": "9",
              "name": "直属单位",
              "pId": "",
              "isParent": 1
          }, {
              "id": "000090",
              "name": "行政部门\/教务处、植物生产国家级实验教学中心、教师发展中心\/实践教学科",
              "pId": "000015",
              "isParent": 0
          }, {
              "id": "000097",
              "name": "行政部门教学机构\/国际合作与交流处、国际教育学院、港澳台办公室\/综合科",
              "pId": "000017",
              "isParent": 0
          }],
      multiValue: '',
      multiOptions: []
    };
  },

  mounted() {
  }
};



// WEBPACK FOOTER //
// ./example/pages/tree-selector.vue